import React from 'react'
import {Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useParams} from 'react-router-dom'
import {usePage} from '@salesforce/commerce-sdk-react'
import PDCBreadcrumb from '../../../components/pdc-breadcrumb/index.jsx'

import {getEnvStaleTime} from '../../../utils/utils.js'
import PropTypes from 'prop-types'

/**
 * @name PDCSubmenu
 * @description Renders the breadcrumb
 * @param {Object} custom - Custom component
 */
export const PDCSubmenu = ({currentPageId}) => {
    const params = useParams()
    const pageId = currentPageId || params.pageId
    const staleTime = getEnvStaleTime()
    const {data: currentPage} = usePage({parameters: {pageId}}, {staleTime: staleTime})

    return (
        <Flex flexDirection="column" alignItems="center" justifyContent="center">
            <PDCBreadcrumb currentPage={currentPage} isRootPage={true} />
        </Flex>
    )
}

PDCSubmenu.propTypes = {
    currentPageId: PropTypes.string
}
